// extracted by mini-css-extract-plugin
export default {"tab_container":"kU_kV","settingsPageSingle":"kU_kW","settings__subtitlesSize":"kU_kX"};